export default "__VITE_ASSET__D_cn1pMP__"